export const productCarouselStyles = {
  root: 'w-full',
  slide: 'h-auto w-[160px] sm:w-[200px] lg:w-[240px]',
  title: 'mb-3 font-heading text-heading-md text-brand-950 sm:text-heading-lg',
} as const;
